// src/actions/noteActions.js

import { getCancelToken } from "../axios/cancelToken"
import { axiosInstance } from "../axios/privateAxios"
import { toast } from 'react-toastify';
import {
    GET_NOTES,
    ADD_NOTE,
    EDIT_NOTE,
    DELETE_NOTE,
    VIEW_NOTE,
    SET_LOADING,
    NOTE_ERROR,
    CRASH_ERROR,
    SET_FETCHING,
} from "./noteTypes"
import { matchFilters } from "../utils/filters";
import axios from "axios";


export const addNote = (note) => async (dispatch, getState) => {
    dispatch({type: SET_LOADING, payload: true})
    try{
        const response = await axiosInstance.post('/notes',note)
        const { search, filterParams } = getState().noteState
        if (matchFilters(response.data,filterParams,search)){
            dispatch({type: ADD_NOTE, payload: response.data})
        }
    }
    catch(err){
        if (err.response?.status === 400){
            throw err
        }
        else{
            toast.error(
                <span style = {{ fontSize: "13.5px", fontFamily: 'Poppins, sans-serif'}}>
                   Unable add note. Try again later!
                </span>,
                {
                    position: "bottom-left"
                }
            )
        }
    }
    finally{
        dispatch({type: SET_LOADING, payload: false})
    }
}

export const deleteNote = (note_id) => async dispatch => {
    dispatch({type: SET_LOADING, payload: true})
    try{
        await axiosInstance.delete(`/notes/${note_id}`)
        dispatch({type: DELETE_NOTE, payload: note_id})
        dispatch({type: SET_LOADING, payload: false})
    }
    catch(err){
        const error = {status: err.response?.status || 500, data: err.response?.data || ""}
        dispatch({type:  NOTE_ERROR,payload: {error, operation: "delete", note_id}})
        dispatch({type: SET_LOADING, payload: false})
        throw(err)
    }
    finally{
        dispatch({type: SET_LOADING, payload: false})
    }
}

export const editNote = (note,id) => async (dispatch, getState) => {
    dispatch({type: SET_LOADING, payload: true})
    try{
        const response = await axiosInstance.put(`/notes/${id}`,note)
        const { search, filterParams } = getState().noteState
        if (matchFilters(response.data,filterParams,search)){
            dispatch({type: EDIT_NOTE, payload: response.data})
        }
        else{
            dispatch({type: DELETE_NOTE, payload: id})
        }
        dispatch({type: SET_LOADING, payload: false})
    }
    catch(err){
        const errorResponse = err.response?.data || {}
        const dataError = err.response?.status === 400 && ('title' in errorResponse || 'content' in errorResponse)
        if (!dataError){
            const error = {status: err.response.status || 500 , data: err.response?.data || ""}
            dispatch({type:  NOTE_ERROR,payload: {error, operation: "edit", note_id: id}})
            dispatch({type: SET_LOADING, payload: false})
        }
        throw err
    }
    finally{
        dispatch({type: SET_LOADING, payload: false})
    }
}

export const viewNote = (note_id) => async dispatch => {
    try{
        const response = await axiosInstance.get(`/notes/${note_id}`)
        dispatch({type: VIEW_NOTE, payload: response.data})
    }
    catch(err){
        const error = {status: err.response?.status || 500, data: err.response?.data || ""}
        dispatch({type:  NOTE_ERROR,payload: {error , operation: "view", note_id }})
    }
}

export const getNotes = () => async(dispatch,getState) => {
    const { search, filterParams, sortParams } = getState().noteState
    let params = {}
    if (search.trim()){
        params.search = search.trim()
    }
    if (!(sortParams.field === "updatedAt" && sortParams.order === "desc")){
        params.sortParam = sortParams.field
        params.sortOrder = sortParams.order
    }
    if (filterParams.color){
        params.color = filterParams.color.name
    }
    if (filterParams.tags.length){
        params.tags = filterParams.tags.map(tag => tag._id)
    }
    dispatch({type: SET_FETCHING, payload: true})
    const cancelSource = getCancelToken()
    try{
        const response = await axiosInstance.get(`/notes`,{params, cancelToken: cancelSource.token})
        dispatch({type: GET_NOTES, payload: response.data})
        dispatch({type: SET_FETCHING, payload: false})
    }
    catch(err){
        if (!axios.isCancel(err)){
            dispatch({type:  CRASH_ERROR, payload: true})
        }
        dispatch({type: SET_FETCHING, payload: false})
    }
}